import "./utils/polyfills";
import "swiper/swiper-bundle.css";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as ChakraThemeProvider } from "@chakra-ui/react";
import "normalize.css";
import "./utils/yupLocale";
import "tippy.js/dist/tippy.css";

import { NuqsAdapter } from "nuqs/adapters/react";
import { theme } from "./theme";
import CreatingCompanyProfile from "./newui/features/Auth";
import MainApp from "./MainApp";
import { useAppSelector } from "newui/store/hooks";
import { AuthContextProvider } from "newui/features/Auth/context/AuthContextProvider";
import { selectIsGuestSwitchLoaded } from "./newui/features/Auth/authSelectors";

function App({ company, getGuestUser, ...props }) {
	const isGuestSwitch = useAppSelector(selectIsGuestSwitchLoaded);

	return (
		<NuqsAdapter>
			<ThemeProvider theme={theme}>
				<ChakraThemeProvider theme={theme}>
					{isGuestSwitch
						? <CreatingCompanyProfile />
						: <AuthContextProvider>
							<MainApp />
						</AuthContextProvider>}
				</ChakraThemeProvider>
			</ThemeProvider>
		</NuqsAdapter>
	);
}

export default App;
